import request from './request';

//获取区域信息
export function getRegionInfo({
  regionLevel,
  limitCount
}: {
  regionLevel: number;
  limitCount: number;
}): Promise<any> {
  return request<{ regionLevel: number; limitCount: number }, any>(
    '/v5/charge/thor/base/getRegionInfo',
    {
      regionLevel,
      limitCount
    },
    'POST'
  );
}

//确认跟物业沟通可以安装
export function confirmInstallation({
  uid,
  orderNo
}: {
  uid: string;
  orderNo: string;
}): Promise<any> {
  return request<{ uid: string; orderNo: string }, any>(
    '/v5/charge/privatePile/homecharge/confirmPropertyManagement',
    {
      uid,
      orderNo
    },
    'GET'
  );
}

//申请报装
interface Info {
  uid: string;
  name: string;
  phone: string;
  orderNo: string;
  contactName: string;
  contactPhone: string;
  province: string;
  provinceCode: string;
  city: string;
  cityCode: string;
  district: string;
  districtCode: string;
  address: string;
}
export function applicationInstallation({
  uid,
  name,
  phone,
  orderNo,
  contactName,
  contactPhone,
  province,
  provinceCode,
  city,
  cityCode,
  district,
  districtCode,
  address
}: Info): Promise<any> {
  return request<Info, any>(
    '/v5/charge/privatePile/homecharge/activateOrder',
    {
      uid,
      name,
      phone,
      orderNo,
      contactName,
      contactPhone,
      province,
      provinceCode,
      city,
      cityCode,
      district,
      districtCode,
      address
    },
    'POST'
  );
}

//获取报装进度
export function getInstallProgress({
  uid,
  orderNo
}: {
  uid: string;
  orderNo: string;
}): Promise<any> {
  return request<{ uid: string; orderNo: string }, any>(
    '/v5/charge/privatePile/homecharge/getInstallProgress',
    {
      uid,
      orderNo
    },
    'POST'
  );
}

//预约勘测时间
export function scheduledSurvey({
  uid,
  orderNo,
  scheduleSurveyTime,
  scheduleSurveyTimeSlot
}: {
  uid: string;
  orderNo: string;
  scheduleSurveyTime: number;
  scheduleSurveyTimeSlot: string;
}): Promise<any> {
  return request<
    {
      uid: string;
      orderNo: string;
      scheduleSurveyTime: number;
      scheduleSurveyTimeSlot: string;
    },
    any
  >(
    '/v5/charge/privatePile/homecharge/editScheduleTime',
    {
      uid,
      orderNo,
      scheduleSurveyTime,
      scheduleSurveyTimeSlot
    },
    'POST'
  );
}

//获取家充工单
export function getHomechargeOrders({
  uid,
  type
}: {
  uid: string;
  type: number;
}): Promise<any> {
  return request<
    {
      uid: string;
      type: number;
    },
    any
  >(
    '/v5/charge/privatePile/homecharge/getHomechargeOrders',
    { uid, type },
    'POST'
  );
}

//确认勘测/安装结果
export function confirmRes({
  uid,
  name,
  taskId,
  orderNo,
  operateCode,
  equipmentCode,
  param
}: {
  uid: string;
  name: string;
  taskId: string;
  orderNo: string;
  operateCode: string;
  equipmentCode: string;
  param: any;
}): Promise<any> {
  return request<
    {
      uid: string;
      name: string;
      taskId: string;
      orderNo: string;
      operateCode: string;
      equipmentCode: string;
      param: any;
    },
    any
  >(
    '/v5/charge/privatePile/homecharge/dealTask',
    {
      uid,
      name,
      taskId,
      orderNo,
      operateCode,
      equipmentCode,
      param
    },
    'POST'
  );
}

//安装进度催办
export function urgeInstallOrder({
  uid,
  name,
  orderNo,
  feedbackType,
  content
}: {
  uid: string;
  name: string;
  orderNo: string;
  feedbackType: number;
  content: string;
}): Promise<any> {
  return request<
    {
      uid: string;
      name: string;
      orderNo: string;
      feedbackType: number;
      content: string;
    },
    any
  >(
    '/v5/charge/privatePile/homecharge/urgeOrder',
    {
      uid,
      name,
      orderNo,
      feedbackType,
      content
    },
    'POST'
  );
}

//获取售后工单进度
export function getAfterSaleProgress({
  uid,
  name,
  orderNo
}: {
  uid: string;
  name: string;
  orderNo: string;
}): Promise<any> {
  return request<
    {
      uid: string;
      name: string;
      orderNo: string;
    },
    any
  >(
    '/v5/charge/privatePile/homecharge/getAfterSaleProgress',
    { uid, name, orderNo },
    'POST'
  );
}

//获取售后工单
export function getAfterOrder({
  privatePileNo
}: {
  privatePileNo: string;
}): Promise<any> {
  return request<{ privatePileNo: string }, any>(
    '/v5/charge/privatePile/homecharge/getAfterSaleOrder',
    { privatePileNo },
    'GET'
  );
}

//确认维修结果
export function afterSaleConfirmRepair({
  uid,
  name,
  orderNo,
  param
}: {
  uid: string;
  name: string;
  orderNo: string;
  param: any;
}): Promise<any> {
  return request<
    {
      uid: string;
      name: string;
      orderNo: string;
      param: any;
    },
    any
  >(
    '/v5/charge/privatePile/homecharge/afterSaleConfirmRepair',
    { uid, name, orderNo, param },
    'POST'
  );
}

//获取家桩信息
export function getPrivatePlieInfo(): Promise<any> {
  return request<{}, any>('/v5/charge/private-pile/query', {}, 'GET');
}

// 获取礼品券信息
export function getCoupons(orderNo): Promise<any> {
  return request<{}, any>('/v5/charge/privatePile/homecharge/queryPurchasePrizeResult', { orderNo }, 'POST');
}

//申请工单报装
export function applyOrder({
  uid,
  name,
  phone,
  orderNo,
  contactName,
  contactPhone,
  province,
  provinceCode,
  city,
  cityCode,
  district,
  districtCode,
  address
}: {
  uid: string;
  name: string;
  phone: string;
  orderNo: string;
  contactName: string;
  contactPhone: string;
  province: string;
  provinceCode: string;
  city: string;
  cityCode: string;
  district: string;
  districtCode: string;
  address: string;
}): Promise<any> {
  return request<
    {
      uid: string;
      name: string;
      phone: string;
      orderNo: string;
      contactName: string;
      contactPhone: string;
      province: string;
      provinceCode: string;
      city: string;
      cityCode: string;
      district: string;
      districtCode: string;
      address: string;
    },
    any
  >(
    '/v5/charge/privatePile/homecharge/activateOrder',
    {
      uid,
      name,
      phone,
      orderNo,
      contactName,
      contactPhone,
      province,
      provinceCode,
      city,
      cityCode,
      district,
      districtCode,
      address
    },
    'POST'
  );
}

export function getHomechargePageUrlByOrderNo({
  externalOrderNo,
  createSource
}: {
  externalOrderNo: string;
  createSource: string;
}): Promise<any> {
  return request<{ externalOrderNo: string; createSource: string }, any>(
    '/v5/charge/privatePile/homecharge/getHomechargePageUrlByExternalOrderNo',
    { externalOrderNo, createSource },
    'GET'
  );
}

export function getHomeChargeAfterSaleUrlByOrderNo({
  purchaseOrderNo,
  createSource
}: {
  purchaseOrderNo: string;
  createSource: string;
}): Promise<any> {
  return request<{ purchaseOrderNo: string; createSource: string }, any>(
    '/v5/charge/privatePile/homecharge/getByPurchaseOrderNo',
    { purchaseOrderNo, createSource },
    'GET'
  );
}

// 售后问卷提交
export function submitAfterSalesQuestionnaire({
  uid,
  name,
  orderNo,
  mark,
  badAttitude,
  arbitraryCharge,
  lowSpeed,
  other,
  info,
}: {
  uid: string;
  name: string;
  orderNo: string;
  mark: number;
  arbitraryCharge: number;
  badAttitude: number;
  lowSpeed: number;
  other: number;
  info: string;
}): Promise<any> {
  return request<
    {
      uid: string;
      name: string;
      orderNo: string;
      mark: number,
      badAttitude: number,
      arbitraryCharge: number,
      lowSpeed: number,
      other: number,
      info: string,
    },
    any
  >(
    '/v5/charge/privatePile/homecharge/submitAfterSaleQuestionnaire',
    {
      uid,
      name,
      orderNo,
      mark,
      badAttitude,
      arbitraryCharge,
      lowSpeed,
      other,
      info,
    },
    'POST'
  );
}
// 售后催办
export function urgeAfterSalesOrder({
  uid,
  name,
  orderNo,
  feedbackType,
  content
}: {
  uid: string;
  name: string;
  orderNo: string;
  feedbackType: number;
  content: string;
}): Promise<any> {
  return request<
    {
      uid: string;
      name: string;
      orderNo: string;
      feedbackType: number;
      content: string;
    },
    any
  >(
    '/v5/charge/privatePile/homecharge/urgeAfterSaleOrder',
    {
      uid,
      name,
      orderNo,
      feedbackType,
      content
    },
    'POST'
  );
}
